export default {
  computed: {
    displaySearchBar() {
      return (this.$mq === 'm768' || this.$mq === 'm992' || this.$mq === 'm1200' )
    },
  }
}
